import { useMutation } from "@tanstack/react-query";
import { ApiError, ApiServiceError } from "libs/api";
import { MutationOptions } from "libs/reactQuery";

import { StaffManagerListItem } from "../../staff.types";
import { requestUpdateStaffManager } from "./updateStaffManager.request";

const useUpdateStaffManager = (
  options?: MutationOptions<StaffManagerListItem, ApiServiceError<ApiError>>
) => {
  return useMutation({
    mutationFn: requestUpdateStaffManager,
    ...options
  });
};

export default useUpdateStaffManager;
